module.exports = __webpack_public_path__ + "img/GWF-Award-banner-003.f8c8cdf8.jpg";